import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from './AuthContext';

export function RequireAuth() {
  const { isAuthenticated, isLoading, mustChangePassword } = useAuth();
  const location = useLocation();
  if (isLoading) return null;
  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search}${location.hash}`;
    const target = from && from !== '/' ? `/login?from=${encodeURIComponent(from)}` : '/login';
    return <Navigate to={target} replace />;
  }
  // A user flagged for a forced password change is pinned to the change-password
  // screen: every other authenticated route bounces there until the flag clears.
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}
